//const o  datos iniciales

const dataInicial = {
  loading: false,
  activo: false,
  arrayUser: [],
};

//type

const LOADING = "LOADING";
const USUARIO_ERROR = "USUARIO_ERROR";
const SET_CREATEUSER = "CREATE_USER";

//reducer

export default function enterUserActionReducer(state = dataInicial, action) {
  switch (action.type) {
    case LOADING:
      return { ...state, loading: action.payload };
    case USUARIO_ERROR:
      return { ...dataInicial };
    case SET_CREATEUSER:
      return {
        ...state,
        arrayUser: action.payload,
      };

    default:
      return { ...state };
  }
}

//action

export const CreateUser = (formLogin) => async (dispatch, getState) => {
  const { arrayUser } = getState().userPort;
  const UserArr = arrayUser.user;
  const PassWordArr = arrayUser.password;


    
  
  try {
    dispatch({
      type: SET_CREATEUSER,
      payload: formLogin,
    });

    dispatch({
      type: LOADING,
      payload: JSON.parse(localStorage.getItem("loading=true")),
    });
    localStorage.setItem("loading=true",JSON.stringify(true) );
    const { arrayUser } = getState().userPort;
    const UserArr = arrayUser.user;
    const PassWordArr = arrayUser.password;
    
    if (UserArr === "admon" && PassWordArr === "1234") {
    } else {
      alert("The User or Password not correct");
    }
  } catch (error) {
    dispatch({
      type: USUARIO_ERROR,
      loading: false,
    });
  }

  /*try{

    const   provider="admon"

  }catch(error){
    console.log(error);
    
  }

*/
};

export const enterUserAction = () => async (dispatch, getState) => {
  const { arrayUser } = getState().userPort;
  console.log(arrayUser);
  try {
    dispatch({
      type: LOADING,
      payload: true,
    });
  } catch (error) {
    dispatch({
      type: USUARIO_ERROR,
      loading: false,
    });
  }
};
